import React, { useEffect } from "react";
import "./marketing.css";
import SiteHeader from "./SiteHeader";
import SiteFooter from "./SiteFooter";
import MineShafts from "./MineShafts";
import StoreCartDrawer from "./store/StoreCartDrawer";

/**
 * Shared marketing shell for all redesigned public pages.
 *
 * Mounts the `.umr` scope root (design tokens + all shell CSS live on it),
 * the fixed header, both mine shafts (with the scroll-riding miner), the
 * page content inside `.u-page` (58px/24px side margins that tuck under the
 * shafts on desktop; 0 on mobile), and the footer.
 *
 * Usage:
 *   <MarketingShell pageClass="pg-home">…page sections…</MarketingShell>
 *
 * The shop's cart drawer is mounted here too, so the header bag button can
 * open it from any page.
 *
 * `pageClass` (e.g. "pg-home") is appended to the root so page CSS can scope
 * as `.umr .pg-<name> …`. Scrolls to top on mount (route change).
 */
export default function MarketingShell({ pageClass = "", children }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      className={"umr" + (pageClass ? " " + pageClass : "")}
      style={{
        // Runtime asset URLs — kept out of the CSS so webpack's css-loader
        // doesn't try to resolve them as modules (they live in public/).
        "--um-shaft-mask": "url('/design/assets/shaft-mask.png')",
        "--um-grit": "url('/design/assets/shaft-grit.png')",
        "--um-hero-cave": "url('/design/assets/hero-cave.jpg')",
      }}
    >
      <SiteHeader />
      <MineShafts />
      <div className="u-page">
        <main>{children}</main>
        <SiteFooter />
      </div>
      <StoreCartDrawer />
    </div>
  );
}
